<template>
  <div>
    <v-app-bar
      absolute
      flat
      app
      color="white"
      height="67px"
      style="border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important"
    >
      <div class="title">{{ title }}</div>
      <template v-if="websiteType !== 'nologin'">
        <v-spacer></v-spacer>
        <v-btn
          class="ml-2"
          v-if="isAuth"
          @click="logout"
          color="primary"
          width="100px"
          tile
          outlined
        >
          Logout
        </v-btn>
        <v-btn
          class="ml-2"
          width="100px"
          v-else
          @click="logout"
          color="primary"
          tile
          outlined
        >
          Login
        </v-btn>
      </template>
    </v-app-bar>
    <Drawer></Drawer>
  </div>
</template>
<script>
import headers from "../assets/labels/header.label";
import Drawer from "../components/Drawer";
export default {
  components: { Drawer },
  data() {
    return {};
  },
  computed: {
    isAuth() {
      return this.$store.getters.user.MobileNo;
    },
    name() {
      let user = this.$store.getters.user;
      if (user.first_name) {
        let { first_name, last_name } = user;
        return `${first_name} ${last_name}`;
      }
      return "";
    },
    title() {
      let { name } = this.$route;
      if (headers[name]) return headers[name];
      return "";
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("user");
      this.$store.commit("SET_USER");
      this.$router.push("/settings");
    },
  },
  mounted() {},
};
</script>

<style></style>
